import { Auth } from "@aws-amplify/auth";

/**
 * These values will become dynamic per each env once the ErgonaCDK is complete.
 */
const REGION = "us-east-1";
const IDENTITY_POOL_ID = "us-east-1:0e9aae65-f0cc-4f40-8f13-17755e5e29fe";
const USER_POOL_ID = "us-east-1_Uem0Hpaua";
const WEB_CLIENT_ID = "170q1nmt8o170ju64gtop9lgbr";
const DOMAIN = `allegro-prod-na.auth.us-east-1.amazoncognito.com`;

export async function Init() {
  const config = {
    stage: "prod",
    aws_cognito_region: REGION,
    aws_cognito_identity_pool_id: IDENTITY_POOL_ID,
    aws_user_pools_id: USER_POOL_ID,
    aws_user_pools_web_client_id: WEB_CLIENT_ID,
    Auth: {
      region: REGION,
      identityPoolId: IDENTITY_POOL_ID,
      userPoolId: USER_POOL_ID,
      userPoolWebClientId: WEB_CLIENT_ID,
    },
    oauth: {
      domain: DOMAIN,
      redirectSignIn: "https://na.headphones.whs.amazon.dev",
      redirectSignOut: "https://na.headphones.whs.amazon.dev",
      scope: ["openid", "profile", "email"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
